
export default {

    csrfToken: 'boma_camp_csrf',
    JWT: 'boma_camp_session_token',
    isSSR: typeof(localStorage) === 'undefined',

    /*
    hello: {

        credentials: {
            facebook: '1695366224070463',
            linkedin: '77g0kw8q3hrxga'
        },

        facebook: {
            scope: 'email',
            redirect_uri: window.location.protocol + '//' + window.location.host + '/login/'
        },

        linkedin: {
            scope: 'r_basicprofile,r_emailaddress',
            redirect_uri: window.location.protocol + '//' + window.location.host + '/login/',
            oauth_proxy: 'https://auth-server.herokuapp.com/proxy'
        }

    },
    */

    setToken(token, cb) {
        if( this.isSSR ) {
            if (cb) cb(true)
            return true;
        }
        localStorage.setItem(this.JWT, token)
        if (cb) cb(true) 
    },

    getToken() {
        if( this.isSSR ) return '';
        return localStorage.getItem(this.JWT)
    },

    loggedIn() {
        return !!this.getToken() && sessionsAllowed();
    },

    logout(cb) {
        if( this.isSSR ) {
            if (cb) cb(true)
            return true;
        }
        if( this.loggedIn() ) {
            localStorage.removeItem(this.JWT)
            if (cb) cb(true)
        }
        if (cb) cb(false)
    },

}

export const sessionsAllowed = () => {
    return process.env.REACT_APP_SESSIONS_ALLOWED === 'TRUE' || false;
}


// WEBPACK FOOTER //
// ./src/js/services/auth.js